import { isReplacementCell, type ReplacementCellSource } from './isReplacementCell';
import { isRealAttendanceRecordId } from './resolveAttendanceAddress';

/**
 * A coverage day that still has only the exception id needs an attendance
 * record before its markings can be viewed or edited.
 */
export const shouldCreateReplacementAttendance = (
  cell?: (ReplacementCellSource & { attendanceRecordId?: string | null }) | null,
): boolean =>
  !!cell && isReplacementCell(cell) && !isRealAttendanceRecordId(cell.attendanceRecordId);
